module.exports = __webpack_public_path__ + "img/pay_step1_right_hover.2ab8a254.png";